module.exports = __webpack_public_path__ + "static/media/JAVI.17b694ca.png";